import React from 'react';
import { useSelector } from "react-redux";
import { WithWorkPlannerUserActivities } from '@features/wall-planner/hooks/WithWorkPlannerUserActivities';
import DateFlicker, { DateScale } from '@shared/ui/molecules/DateFlicker';
import { WorkPlannerControls, WorkPlannerHeader, } from '@shared/ui/molecules/work-planner/WorkPlannerStructure';
import { TeamMultiSelectWithFavourites } from '@shared/ui/organisms/team-drop-down-list/TeamMultiSelectWithFavourites';
import { TeamEntity } from '@shared/models/team.models';
import { Tag } from '@shared/models/tags.models';
import { WorkPlannerLayout } from '@shared/ui/molecules/work-planner/WorkPlannerLayout';
import { WithWeeksInCurrentCalendarMonth } from '@features/whereabouts/hooks/WithWeekInCurrentCalendarMonth';
import { selectAllTeams } from '@shared/store/config.duck';
import { selectAllTags } from '@shared/store/userTags.duck';
import { PageTitle } from '@shared/ui/atoms/PageTitle';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { BiggerThanTabletOnly, TabletOnly } from '@shared/ui/atoms/DeviceSpecific';
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import { MonthlyWhereaboutsView } from "./MonthlyWhereaboutsView";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function WorkPlannerPage() {
  const allTeams = useSelector(selectAllTeams);
  const workGroups = useSelector(selectAllTags);

  const weeksInMonth = WithWeeksInCurrentCalendarMonth();
  WithWorkPlannerUserActivities();
  const calendarDate = useSelector(selectCalendarDate);

  const onGroupsSelected = (team: TeamEntity[], workGroups: Tag[]) => {

  }

  return (
    <WorkPlannerLayout numberOfWeeksInMonth={weeksInMonth.length+1}>
      <TabletOnly style={{padding: '0 16px', marginTop: 8}}>
        <PageTitle includeMobileGutters={true} text={'work-planner.work-planner'} />
        <DateFlicker dateScale={DateScale.Month} updateGlobalDate={true} restrictPastWhereabouts={true} date={calendarDate} />
      </TabletOnly>
      <WorkPlannerHeader>
        <BiggerThanTabletOnly style={{minWidth: 300}}>
          <PageTitle text={'work-planner.work-planner'} />
        </BiggerThanTabletOnly>
        <WorkPlannerControls>
          <TeamMultiSelectWithFavourites onSelect={onGroupsSelected}
                                         teams={allTeams}
                                         workGroups={workGroups}
                                         outerClassName={'multiSelect__wrapper'}
                                         multiSelectClassName={'multiSelect__dropDown'}
                                         reloadTeamWhereaboutsOnSelect={true} />
          <OutlineButton link="/whereabouts/work-planner/event"
                         text="work-planner.add-event-project"
                         fullWidth={false}
                         style={{maxWidth: 220, marginBottom: 0}}
                         size={ButtonSize.Medium}/>
        </WorkPlannerControls>
      </WorkPlannerHeader>
      <MonthlyWhereaboutsView />
    </WorkPlannerLayout>
  )
}
